import React, { Component } from 'react';
// import Wrp from '../../../hoc/Wrp/Wrp';

class UploadStatus extends Component {
    
    render () {
        const {colData,id} = this.props;
        //status: SUCCESS,FAILURE,WARNING
        //PERCENTAGE AND MESSAGE
        let statusClass = 'bg-dark';
        let textClass = 'text-dark';
        if(colData.status==='SUCCESS'){
            statusClass = 'bg-success';
            textClass = 'text-success';
        }else if(colData.status==='WARNING'){
            statusClass = 'bg-warning';
            textClass = 'text-success';
        }
        // console.log(statusClass);
        return(
            <td key={id} className="card-list p-0">
                <div className="d-block align-items-center">
                <div>
			    <div className={`progress ${statusClass}`}>
					<div className={`progress-bar ${statusClass}`} role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax={colData.percentage} style={{width:colData.percentage+'%'}}>
                    </div>
				</div>
				</div>
				    <span className={`completion ml-2 text-small ${textClass}`}>{colData.percentage}&nbsp;{colData.message}</span>
				</div>
            </td>
        );
    }
}

export default UploadStatus;